import { MoovInstanceDTO } from "../DTO/moovInstanceDTO";
import { MoovConfiguration } from "./moovConfiguration";
import { MoovFile } from "./moovFile";
import { MoovStepInstance } from "./moovStepInstance";

export class MoovInstance{
    public id!:number;
    public customerId!:number;
    public moovConfiguration!:MoovConfiguration;
    public triggerFile?:MoovFile;
    public sourceFile!:MoovFile;
    public resultFile!:MoovFile;
    public collatedFiles?:MoovFile[];
    public failedTrigger?:boolean;
    public failedTriggerReason?:string;
    public status!:number; //0=created, 1=in process, 2=completed, 3=failed, 4=deleted, 5=suspended
    public configurationStatus!:number; //0=Draft, 1=Testing, 2=Active, 3=Inactive
    public collisionId?:string; //a guid which is set to all instances currently in a collision relative to each other and referenced in action item 
    public added!:Date;
    public updated?:Date;
    public executeOnOrAfter?:Date;
    public startedAt?:Date;
    public completedAt?:Date;
    public stepInstances!: MoovStepInstance[];
    public addedByUserId?:number;
    public remarks?:string;

    public formattedRemarks?:string;

    constructor(){
        this.stepInstances=[];
        this.collatedFiles=[];
    }

    public static mapFromDTO(param:MoovInstanceDTO):MoovInstance{ 
        if (!param) throw new Error("parameter is null")
        let obj = new MoovInstance();
        try
        {
            obj.id = param.id;
            obj.customerId = param.customerId;
            obj.moovConfiguration = MoovConfiguration.mapFromDTO(param.moovConfiguration);
            obj.sourceFile = MoovFile.mapFromDTO(param.sourceFile);
            if(param.resultFile) obj.resultFile = MoovFile.mapFromDTO(param.resultFile);
            if(param.triggerFile) obj.triggerFile = MoovFile.mapFromDTO(param.triggerFile);
            if(param.collatedFiles) obj.collatedFiles = param.collatedFiles.map(cf=> MoovFile.mapFromDTO(cf));
            obj.status = param.status;
            obj.configurationStatus = param.configurationStatus;
            obj.failedTrigger = param.failedTrigger;
            obj.failedTriggerReason = param.failedTriggerReason;
            obj.collisionId = param.collisionId;
            obj.added = new Date(param.added);
            if(param.updated) obj.updated = new Date(param.updated);
            if(param.executeOnOrAfter) obj.executeOnOrAfter = new Date(param.executeOnOrAfter);
            if(param.startedAt) obj.startedAt = new Date(param.startedAt);
            if(param.completedAt) obj.completedAt = new Date(param.completedAt);
            obj.stepInstances = param.stepInstances.map(si=>MoovStepInstance.mapFromDTO(si));
            obj.addedByUserId = param.addedByUserId;
            obj.remarks = param.remarks;
            obj.formattedRemarks=obj.remarks?.replace(/<i>/g,"").replace(/<\/i>/g,"").replace(/<b>/g,"").replace(/<\/b>/g,"").split('</br>').join('\n');
        }
        catch(e)
        {
            console.log(e);
            
        }
        return obj;
    }

    public static mapToDTO(param:MoovInstance):MoovInstanceDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new MoovInstanceDTO();
        try
        {
            dto.id = param.id;
            dto.customerId = param.customerId;
            dto.moovConfiguration = MoovConfiguration.mapToDTO(param.moovConfiguration);
            dto.sourceFile = MoovFile.mapToDTO(param.sourceFile);
            if(param.resultFile) dto.resultFile = MoovFile.mapToDTO(param.resultFile);
            if(param.triggerFile) dto.triggerFile = MoovFile.mapToDTO(param.triggerFile);
            if(param.collatedFiles) dto.collatedFiles = param.collatedFiles.map(cf=> MoovFile.mapToDTO(cf));
            dto.status = param.status;
            dto.configurationStatus = param.configurationStatus;
            dto.failedTrigger = param.failedTrigger;
            dto.failedTriggerReason = param.failedTriggerReason;
            dto.collisionId = param.collisionId;
            dto.added = param.added.toISOString();
            if(param.updated) dto.updated = param.updated.toISOString();
            if(param.executeOnOrAfter) dto.executeOnOrAfter = param.executeOnOrAfter.toISOString();
            if(param.startedAt) dto.startedAt = param.startedAt.toISOString();
            if(param.completedAt) dto.completedAt = param.completedAt.toISOString();
            dto.stepInstances = param.stepInstances.map(si=>MoovStepInstance.mapToDTO(si));
            dto.addedByUserId = param.addedByUserId;
            dto.remarks = param.remarks;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return dto;
    }

    get displayStatus(){
        switch(this.status){
            case 0:
                return (this.startedAt)? "created" : "collating until " + this.executeOnOrAfter?.toLocaleString();
            case 1:
                return "processing";
            case 2:
                return "completed";
            case 3:
                return "failed";
            case 4:
                return "deleted";
            case 5:
                return (this.collisionId)?"suspended (collision)":"suspended";
            default:
                return "unknown";
        }
    }

    get displayConfigurationStatus(){
        switch(this.configurationStatus){
            case 0:
                return "Draft";
            case 1:
                return "Testing";
            case 2:
                return "Active";
            case 3:
                return "Inactive";
            default:
                return "";
        }
    }

    get undoInProcess(){
        return this.stepInstances.findIndex(si=>si.undoInProcess==true)>-1;
    }

}